import {
  CREATE_FACILITY_HOLIDAY,
  CREATE_FACILITY_HOLIDAY_SUCCESS,
  CREATE_FACILITY_HOLIDAY_ERROR,
  CREATE_FACILITY_HOLIDAY_EMPTY,
} from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const CreateFacilityHoliday = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_FACILITY_HOLIDAY:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CREATE_FACILITY_HOLIDAY_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case CREATE_FACILITY_HOLIDAY_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CREATE_FACILITY_HOLIDAY_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default CreateFacilityHoliday;
